<template>
  <v-dialog width="500" v-model="showIMOClassForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> {{ editMode ? "Update" : "Add" }} IMCO Class </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showIMOClassForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form ref="IMOClassForm" v-if="showIMOClassForm" v-model="isValid">
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="IMCO Class *"
                required
                :rules="[(val) => !!val || 'IMCO Class is Required!']"
                hide-details="auto"
                v-model="formDetails.imo_class"
                :error-messages="formErrors.imo_class"
                @input="delete formErrors.imo_class"
              />
            </v-col>

            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="Description"
                hide-details="auto"
                v-model="formDetails.imo_description"
                :error-messages="formErrors.imo_description"
                @input="delete formErrors.imo_description"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>

        <v-btn
          class="ml-2"
          color="secondary"
          v-if="!editMode"
          depressed
          @click="resetForm"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editIMOClassID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getIMOClassObject(this.editIMOClassID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showIMOClassForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formDetails: {},
      formErrors: {},
      isTextInput: false,
      isValid: true,
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.formDetails = {
          ...this.formDetails,
        };
        this.$api.imoClass
          .addIMOClass(this.formDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "IMO Class added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showIMOClassForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add IMO Class!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.imoClass
          .updateIMOClass({ id: this.formDetails.id, data: this.formDetails })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "IMO Class updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showIMOClassForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update IMO Class!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.IMOClassForm) {
        this.$refs.IMOClassForm.reset();
      }
      this.formDetails = {};
    },

    getIMOClassObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.imoClass
        .getIMOClassObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.formDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
